import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {AuthService} from './auth.service';
import {UserService} from './user.service';
import {AppConfig} from 'app/app.config';
import {ActService} from 'app/services/act.service';


@Injectable()
export class ApiService {

  auth: AuthService;
  user: UserService;
  act: ActService;

  constructor(private http: HttpClient, private config: AppConfig) {
    this.auth = new AuthService(http, config);
    this.act = new ActService(http, config);
    this.user = new UserService(http, config);
  }
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/services/api.service.ts